import React from 'react';
import { AnomalyDetection } from 'prophesier/dist/wrapper/index-with-deps-react.js';

class AnomalySample extends React.Component {
    constructor() {
        super()
    }
    render() {
        const inputData = this.getData()
        return <AnomalyDetection traindata={inputData.trainData} predictdata={inputData.predictData} steps={4} epsilon={0.01} result={this._onresult} />
    }
    getData() {
        const trainData = [{"date": "03/15/2017 06:00", 
              "value": 2
        }, { 
              "date": "03/15/2017 12:00", 
              "value": 4 
        }, { 
                  "date": "03/15/2017 18:00", 
                  "value": 6 
            }, { 
                  "date": "03/16/2017 00:00", 
                  "value": 10
            }, { 
                  "date": "03/16/2017 06:00", 
                  "value": 3 
            }, { 
                  "date": "03/16/2017 12:00", 
                  "value": 3 
            }, { 
                  "date": "03/16/2017 18:00", 
                  "value": 7 
            }, { 
                  "date": "03/17/2017 00:00", 
                  "value": 9 
            }, { 
                  "date": "03/17/2017 06:00", 
                  "value": 2 
            }, { 
                  "date": "03/17/2017 12:00", 
                  "value": 5 
            }, { 
                  "date": "03/17/2017 18:00", 
                  "value": 7 
            }, { 
                  "date": "03/18/2017 00:00", 
                  "value": 10 
            }, { 
                  "date": "03/18/2017 06:00", 
                  "value": 2 
            }, { 
                  "date": "03/18/2017 12:00", 
                  "value": 3 
            }, { 
                  "date": "03/18/2017 18:00", 
                  "value": 7 
            }, { 
                  "date": "03/19/2017 00:00", 
                  "value": 9 
            }, { 
                  "date": "03/19/2017 06:00", 
                  "value": 3 
            }, { 
                  "date": "03/19/2017 12:00", 
                  "value": 4 
            }, { 
                  "date": "03/19/2017 18:00", 
                  "value": 6 
            }, { 
                  "date": "03/20/2017 00:00", 
                  "value": 10 
            }, { 
                  "date": "03/20/2017 06:00", 
                  "value": 1 
            }, { 
                  "date": "03/20/2017 12:00", 
                  "value": 5 
            }, { 
                  "date": "03/20/2017 18:00", 
                  "value": 8 
            }, { 
                  "date": "03/21/2017 00:00", 
                  "value": 8 
            }, { 
                  "date": "03/21/2017 06:00", 
                  "value": 2 
            }, { 
                  "date": "03/21/2017 12:00", 
                  "value": 5 
            }, { 
                  "date": "03/21/2017 18:00", 
                  "value": 8 
            }, { 
                  "date": "03/22/2017 00:00", 
                  "value": 9 
            }, { 
                  "date": "03/22/2017 06:00", 
                  "value": 2 
            }, { 
                  "date": "03/22/2017 12:00", 
                  "value": 4 
            }, { 
                  "date": "03/22/2017 18:00", 
                  "value": 7 
            }, { 
                  "date": "03/23/2017 00:00", 
                  "value": 9 
            }, { 
                  "date": "03/23/2017 06:00", 
                  "value": 1 
            }, { 
                  "date": "03/23/2017 12:00", 
                  "value": 3 
            }, { 
                  "date": "03/23/2017 18:00", 
                  "value": 3.5 
            }, { 
                  "date": "03/24/2017 00:00", 
                  "value": 9 
            }, { 
                  "date": "03/24/2017 06:00", 
                  "value": 1 
            }, { 
                  "date": "03/24/2017 12:00", 
                  "value": 3 
            }, { 
                  "date": "03/24/2017 18:00", 
                  "value": 7 
            }, { 
                  "date": "03/25/2017 00:00", 
                  "value": 9 
            }, { 
                  "date": "03/25/2017 06:00", 
                  "value": 2 
            }, { 
                  "date": "03/25/2017 12:00", 
                  "value": 3 
            }, { 
                  "date": "03/25/2017 18:00", 
                  "value": 7 
            }, { 
                  "date": "03/26/2017 00:00", 
                  "value": 9 
            }, { 
                  "date": "03/26/2017 06:00", 
                  "value": 3 
            }, { 
                  "date": "03/26/2017 12:00", 
                  "value": 4 
            }, { 
                  "date": "03/26/2017 18:00", 
                  "value": 6 
            }, { 
                  "date": "03/27/2017 00:00", 
                  "value": 9 
            }, { 
                  "date": "03/27/2017 06:00", 
                  "value": 2 
            }, { 
                  "date": "03/27/2017 12:00", 
                  "value": 4 
            }, { 
                  "date": "03/27/2017 18:00", 
                  "value": 7 
            }, { 
                  "date": "03/28/2017 00:00", 
                  "value": 10 
            }, { 
                  "date": "03/28/2017 06:00", 
                  "value": 1 
            }, { 
                  "date": "03/28/2017 12:00", 
                  "value": 4 
            }, { 
                  "date": "03/28/2017 18:00", 
                  "value": 7 
            }, { 
                  "date": "03/29/2017 00:00", 
                  "value": 8 
            }, { 
                  "date": "03/29/2017 06:00", 
                  "value": 2 
            }, { 
                  "date": "03/29/2017 12:00", 
                  "value": 4 
            }, { 
                  "date": "03/29/2017 18:00", 
                  "value": 8 
            }, { 
                  "date": "03/30/2017 00:00", 
                  "value": 9 
            }, { 
                  "date": "03/30/2017 06:00", 
                  "value": 2 
            }, { 
                  "date": "03/30/2017 12:00", 
                  "value": 4 
            }, { 
                  "date": "03/30/2017 18:00", 
                  "value": 6 
            }] 

    const predictData = [{"date": "03/15/2017 06:00", 
              "value": 2 
        }, { 
              "date": "03/15/2017 12:00", 
              "value": 4 
        }, { 
                  "date": "03/15/2017 18:00", 
                  "value": 6 
            }, { 
                  "date": "03/16/2017 00:00", 
                  "value": 10 
            }, { 
                  "date": "03/16/2017 06:00", 
                  "value": 3 
            }, { 
                  "date": "03/16/2017 12:00", 
                  "value": 3 
            }, { 
                  "date": "03/16/2017 18:00", 
                  "value": 7 
            }, { 
                  "date": "03/17/2017 00:00", 
                  "value": 9 
            }, { 
                  "date": "03/17/2017 06:00", 
                  "value": 2 
            }, { 
                  "date": "03/17/2017 12:00", 
                  "value": 5 
            }, { 
                  "date": "03/17/2017 18:00", 
                  "value": 7 
            }, { 
                  "date": "03/18/2017 00:00", 
                  "value": 10 
            }, { 
                  "date": "03/18/2017 06:00", 
                  "value": 2 
            }, { 
                  "date": "03/18/2017 12:00", 
                  "value": 3 
            }, { 
                  "date": "03/18/2017 18:00", 
                  "value": 7 
            }, { 
                  "date": "03/19/2017 00:00", 
                  "value": 9 
            }, { 
                  "date": "03/19/2017 06:00", 
                  "value": 3 
            }, { 
                  "date": "03/19/2017 12:00", 
                  "value": 4 
            }, { 
                  "date": "03/19/2017 18:00", 
                  "value": 6 
            }, { 
                  "date": "03/20/2017 00:00", 
                  "value": 10 
            }, { 
                  "date": "03/20/2017 06:00", 
                  "value": 1 
            }, { 
                  "date": "03/20/2017 12:00", 
                  "value": 5 
            }, { 
                  "date": "03/20/2017 18:00", 
                  "value": 8 
            }, { 
                  "date": "03/21/2017 00:00", 
                  "value": 8 
            }, { 
                  "date": "03/21/2017 06:00", 
                  "value": 2 
            }, { 
                  "date": "03/21/2017 12:00", 
                  "value": 5 
            }, { 
                  "date": "03/21/2017 18:00", 
                  "value": 8 
            }, { 
                  "date": "03/22/2017 00:00", 
                  "value": 9 
            }, { 
                  "date": "03/22/2017 06:00", 
                  "value": 2 
            }, { 
                  "date": "03/22/2017 12:00", 
                  "value": 4 
            }, { 
                  "date": "03/22/2017 18:00", 
                  "value": 1 
            }, { 
                  "date": "03/23/2017 00:00", 
                  "value": 1 
            }, { 
                  "date": "03/23/2017 06:00", 
                  "value": 1 
            }, { 
                  "date": "03/23/2017 12:00", 
                  "value": 3 
            }, { 
                  "date": "03/23/2017 18:00", 
                  "value": 3.5 
            }, { 
                  "date": "03/24/2017 00:00", 
                  "value": 9 
            }, { 
                  "date": "03/24/2017 06:00", 
                  "value": 1 
            }, { 
                  "date": "03/24/2017 12:00", 
                  "value": 3 
            }, { 
                  "date": "03/24/2017 18:00", 
                  "value": 7 
            }, { 
                  "date": "03/25/2017 00:00", 
                  "value": 9 
            }, { 
                  "date": "03/25/2017 06:00", 
                  "value": 2 
            }, { 
                  "date": "03/25/2017 12:00", 
                  "value": 3 
            }, { 
                  "date": "03/25/2017 18:00", 
                  "value": 7 
            }, { 
                  "date": "03/26/2017 00:00", 
                  "value": 9 
            }, { 
                  "date": "03/26/2017 06:00", 
                  "value": 3 
            }, { 
                  "date": "03/26/2017 12:00", 
                  "value": 4 
            }, { 
                  "date": "03/26/2017 18:00", 
                  "value": 6 
            }, { 
                  "date": "03/27/2017 00:00", 
                  "value": 9 
            }, { 
                  "date": "03/27/2017 06:00", 
                  "value": 2 
            }, { 
                  "date": "03/27/2017 12:00", 
                  "value": 4 
            }, { 
                  "date": "03/27/2017 18:00", 
                  "value": 7 
            }, { 
                  "date": "03/28/2017 00:00", 
                  "value": 10 
            }, { 
                  "date": "03/28/2017 06:00", 
                  "value": 1 
            }, { 
                  "date": "03/28/2017 12:00", 
                  "value": 4 
            }, { 
                  "date": "03/28/2017 18:00", 
                  "value": 7 
            }, { 
                  "date": "03/29/2017 00:00", 
                  "value": 8 
            }, { 
                  "date": "03/29/2017 06:00", 
                  "value": 2 
            }, { 
                  "date": "03/29/2017 12:00", 
                  "value": 4 
            }, { 
                  "date": "03/29/2017 18:00", 
                  "value": 8 
            }, { 
                  "date": "03/30/2017 00:00", 
                  "value": 9 
            }, { 
                  "date": "03/30/2017 06:00", 
                  "value": 2 
            }, { 
                  "date": "03/30/2017 12:00", 
                  "value": 4 
            }, { 
                  "date": "03/30/2017 18:00", 
                  "value": 6 
            }] 
        return {trainData, predictData}
    }
}

export default AnomalySample;

export const textCode = `
import React from 'react';
import { AnomalyDetection } from 'prophesier/dist/wrapper/index-with-deps-react.js';

class DescriptiveGPUSample extends React.Component {
    constructor() {
        super()
    }
    _onresult(event) {
        console.log(event)
    }
    render() {
        const inputData = this.getData()
        return <AnomalyDetection 
                        traindata={inputData.trainData} 
                        predictdata={inputData.predictData} 
                        steps={4} 
                        epsilon={0.01} 
                        result={this._onresult.bind(this)} />
    }
    getData() {
        const trainData = [{"date": "03/15/2017 06:00", 
              "value": 2
        }, { 
              "date": "03/15/2017 12:00", 
              "value": 4 
        }, { 
                  "date": "03/15/2017 18:00", 
                  "value": 6 
            }, { 
                  "date": "03/16/2017 00:00", 
                  "value": 10
            }, { 
                  "date": "03/16/2017 06:00", 
                  "value": 3 
            }, { 
                  "date": "03/16/2017 12:00", 
                  "value": 3 
            }, { 
                  "date": "03/16/2017 18:00", 
                  "value": 7 
            }, { 
                  "date": "03/17/2017 00:00", 
                  "value": 9 
            }, { 
                  "date": "03/17/2017 06:00", 
                  "value": 2 
            }, { 
                  "date": "03/17/2017 12:00", 
                  "value": 5 
            }, { 
                  "date": "03/17/2017 18:00", 
                  "value": 7 
            }, { 
                  "date": "03/18/2017 00:00", 
                  "value": 10 
            }, { 
                  "date": "03/18/2017 06:00", 
                  "value": 2 
            }, { 
                  "date": "03/18/2017 12:00", 
                  "value": 3 
            }, { 
                  "date": "03/18/2017 18:00", 
                  "value": 7 
            }, { 
                  "date": "03/19/2017 00:00", 
                  "value": 9 
            }, { 
                  "date": "03/19/2017 06:00", 
                  "value": 3 
            }, { 
                  "date": "03/19/2017 12:00", 
                  "value": 4 
            }, { 
                  "date": "03/19/2017 18:00", 
                  "value": 6 
            }, { 
                  "date": "03/20/2017 00:00", 
                  "value": 10 
            }, { 
                  "date": "03/20/2017 06:00", 
                  "value": 1 
            }, { 
                  "date": "03/20/2017 12:00", 
                  "value": 5 
            }, { 
                  "date": "03/20/2017 18:00", 
                  "value": 8 
            }, { 
                  "date": "03/21/2017 00:00", 
                  "value": 8 
            }, { 
                  "date": "03/21/2017 06:00", 
                  "value": 2 
            }, { 
                  "date": "03/21/2017 12:00", 
                  "value": 5 
            }, { 
                  "date": "03/21/2017 18:00", 
                  "value": 8 
            }, { 
                  "date": "03/22/2017 00:00", 
                  "value": 9 
            }, { 
                  "date": "03/22/2017 06:00", 
                  "value": 2 
            }, { 
                  "date": "03/22/2017 12:00", 
                  "value": 4 
            }, { 
                  "date": "03/22/2017 18:00", 
                  "value": 7 
            }, { 
                  "date": "03/23/2017 00:00", 
                  "value": 9 
            }, { 
                  "date": "03/23/2017 06:00", 
                  "value": 1 
            }, { 
                  "date": "03/23/2017 12:00", 
                  "value": 3 
            }, { 
                  "date": "03/23/2017 18:00", 
                  "value": 3.5 
            }, { 
                  "date": "03/24/2017 00:00", 
                  "value": 9 
            }, { 
                  "date": "03/24/2017 06:00", 
                  "value": 1 
            }, { 
                  "date": "03/24/2017 12:00", 
                  "value": 3 
            }, { 
                  "date": "03/24/2017 18:00", 
                  "value": 7 
            }, { 
                  "date": "03/25/2017 00:00", 
                  "value": 9 
            }, { 
                  "date": "03/25/2017 06:00", 
                  "value": 2 
            }, { 
                  "date": "03/25/2017 12:00", 
                  "value": 3 
            }, { 
                  "date": "03/25/2017 18:00", 
                  "value": 7 
            }, { 
                  "date": "03/26/2017 00:00", 
                  "value": 9 
            }, { 
                  "date": "03/26/2017 06:00", 
                  "value": 3 
            }, { 
                  "date": "03/26/2017 12:00", 
                  "value": 4 
            }, { 
                  "date": "03/26/2017 18:00", 
                  "value": 6 
            }, { 
                  "date": "03/27/2017 00:00", 
                  "value": 9 
            }, { 
                  "date": "03/27/2017 06:00", 
                  "value": 2 
            }, { 
                  "date": "03/27/2017 12:00", 
                  "value": 4 
            }, { 
                  "date": "03/27/2017 18:00", 
                  "value": 7 
            }, { 
                  "date": "03/28/2017 00:00", 
                  "value": 10 
            }, { 
                  "date": "03/28/2017 06:00", 
                  "value": 1 
            }, { 
                  "date": "03/28/2017 12:00", 
                  "value": 4 
            }, { 
                  "date": "03/28/2017 18:00", 
                  "value": 7 
            }, { 
                  "date": "03/29/2017 00:00", 
                  "value": 8 
            }, { 
                  "date": "03/29/2017 06:00", 
                  "value": 2 
            }, { 
                  "date": "03/29/2017 12:00", 
                  "value": 4 
            }, { 
                  "date": "03/29/2017 18:00", 
                  "value": 8 
            }, { 
                  "date": "03/30/2017 00:00", 
                  "value": 9 
            }, { 
                  "date": "03/30/2017 06:00", 
                  "value": 2 
            }, { 
                  "date": "03/30/2017 12:00", 
                  "value": 4 
            }, { 
                  "date": "03/30/2017 18:00", 
                  "value": 6 
            }] 

     const predictData = [{"date": "03/15/2017 06:00", 
              "value": 2 
        }, { 
              "date": "03/15/2017 12:00", 
              "value": 4 
        }, { 
                  "date": "03/15/2017 18:00", 
                  "value": 6 
            }, { 
                  "date": "03/16/2017 00:00", 
                  "value": 10 
            }, { 
                  "date": "03/16/2017 06:00", 
                  "value": 3 
            }, { 
                  "date": "03/16/2017 12:00", 
                  "value": 3 
            }, { 
                  "date": "03/16/2017 18:00", 
                  "value": 7 
            }, { 
                  "date": "03/17/2017 00:00", 
                  "value": 9 
            }, { 
                  "date": "03/17/2017 06:00", 
                  "value": 2 
            }, { 
                  "date": "03/17/2017 12:00", 
                  "value": 5 
            }, { 
                  "date": "03/17/2017 18:00", 
                  "value": 7 
            }, { 
                  "date": "03/18/2017 00:00", 
                  "value": 10 
            }, { 
                  "date": "03/18/2017 06:00", 
                  "value": 2 
            }, { 
                  "date": "03/18/2017 12:00", 
                  "value": 3 
            }, { 
                  "date": "03/18/2017 18:00", 
                  "value": 7 
            }, { 
                  "date": "03/19/2017 00:00", 
                  "value": 9 
            }, { 
                  "date": "03/19/2017 06:00", 
                  "value": 3 
            }, { 
                  "date": "03/19/2017 12:00", 
                  "value": 4 
            }, { 
                  "date": "03/19/2017 18:00", 
                  "value": 6 
            }, { 
                  "date": "03/20/2017 00:00", 
                  "value": 10 
            }, { 
                  "date": "03/20/2017 06:00", 
                  "value": 1 
            }, { 
                  "date": "03/20/2017 12:00", 
                  "value": 5 
            }, { 
                  "date": "03/20/2017 18:00", 
                  "value": 8 
            }, { 
                  "date": "03/21/2017 00:00", 
                  "value": 8 
            }, { 
                  "date": "03/21/2017 06:00", 
                  "value": 2 
            }, { 
                  "date": "03/21/2017 12:00", 
                  "value": 5 
            }, { 
                  "date": "03/21/2017 18:00", 
                  "value": 8 
            }, { 
                  "date": "03/22/2017 00:00", 
                  "value": 9 
            }, { 
                  "date": "03/22/2017 06:00", 
                  "value": 2 
            }, { 
                  "date": "03/22/2017 12:00", 
                  "value": 4 
            }, { 
                  "date": "03/22/2017 18:00", 
                  "value": 1 
            }, { 
                  "date": "03/23/2017 00:00", 
                  "value": 1 
            }, { 
                  "date": "03/23/2017 06:00", 
                  "value": 1 
            }, { 
                  "date": "03/23/2017 12:00", 
                  "value": 3 
            }, { 
                  "date": "03/23/2017 18:00", 
                  "value": 3.5 
            }, { 
                  "date": "03/24/2017 00:00", 
                  "value": 9 
            }, { 
                  "date": "03/24/2017 06:00", 
                  "value": 1 
            }, { 
                  "date": "03/24/2017 12:00", 
                  "value": 3 
            }, { 
                  "date": "03/24/2017 18:00", 
                  "value": 7 
            }, { 
                  "date": "03/25/2017 00:00", 
                  "value": 9 
            }, { 
                  "date": "03/25/2017 06:00", 
                  "value": 2 
            }, { 
                  "date": "03/25/2017 12:00", 
                  "value": 3 
            }, { 
                  "date": "03/25/2017 18:00", 
                  "value": 7 
            }, { 
                  "date": "03/26/2017 00:00", 
                  "value": 9 
            }, { 
                  "date": "03/26/2017 06:00", 
                  "value": 3 
            }, { 
                  "date": "03/26/2017 12:00", 
                  "value": 4 
            }, { 
                  "date": "03/26/2017 18:00", 
                  "value": 6 
            }, { 
                  "date": "03/27/2017 00:00", 
                  "value": 9 
            }, { 
                  "date": "03/27/2017 06:00", 
                  "value": 2 
            }, { 
                  "date": "03/27/2017 12:00", 
                  "value": 4 
            }, { 
                  "date": "03/27/2017 18:00", 
                  "value": 7 
            }, { 
                  "date": "03/28/2017 00:00", 
                  "value": 10 
            }, { 
                  "date": "03/28/2017 06:00", 
                  "value": 1 
            }, { 
                  "date": "03/28/2017 12:00", 
                  "value": 4 
            }, { 
                  "date": "03/28/2017 18:00", 
                  "value": 7 
            }, { 
                  "date": "03/29/2017 00:00", 
                  "value": 8 
            }, { 
                  "date": "03/29/2017 06:00", 
                  "value": 2 
            }, { 
                  "date": "03/29/2017 12:00", 
                  "value": 4 
            }, { 
                  "date": "03/29/2017 18:00", 
                  "value": 8 
            }, { 
                  "date": "03/30/2017 00:00", 
                  "value": 9 
            }, { 
                  "date": "03/30/2017 06:00", 
                  "value": 2 
            }, { 
                  "date": "03/30/2017 12:00", 
                  "value": 4 
            }, { 
                  "date": "03/30/2017 18:00", 
                  "value": 6 
            }] 
        return {trainData, predictData}
    }
}

export default DescriptiveGPUSample;
`

export const src = `

const template = "<prophesier-anomaly-detection></prophesier-anomaly-detection>";

document.onreadystatechange = () => {
    if (document.readyState === "complete") {
        const sampleCode  = document.querySelector("._sampleDomElement");
        sampleCode.innerHTML = template
        const element = document.querySelector("prophesier-anomaly-detection")
        const inputdata = getData()
        element.traindata = inputdata.trainData 
        element.predictdata = inputdata.predictData  
        element.steps = 4 
        element.epsilon= 0.01
    }
}

function getData() {
    const trainData = [{"date": "03/15/2017 06:00", 
            "value": 2
        }, { 
            "date": "03/15/2017 12:00", 
            "value": 4 
        }, { 
              "date": "03/15/2017 18:00", 
              "value": 6 
        }, { 
              "date": "03/16/2017 00:00", 
              "value": 10
        }, { 
              "date": "03/16/2017 06:00", 
              "value": 3 
        }, { 
              "date": "03/16/2017 12:00", 
              "value": 3 
        }, { 
              "date": "03/16/2017 18:00", 
              "value": 7 
        }, { 
              "date": "03/17/2017 00:00", 
              "value": 9 
        }, { 
              "date": "03/17/2017 06:00", 
              "value": 2 
        }, { 
              "date": "03/17/2017 12:00", 
              "value": 5 
        }, { 
              "date": "03/17/2017 18:00", 
              "value": 7 
        }, { 
              "date": "03/18/2017 00:00", 
              "value": 10 
        }, { 
              "date": "03/18/2017 06:00", 
              "value": 2 
        }, { 
              "date": "03/18/2017 12:00", 
              "value": 3 
        }, { 
              "date": "03/18/2017 18:00", 
              "value": 7 
        }, { 
              "date": "03/19/2017 00:00", 
              "value": 9 
        }, { 
              "date": "03/19/2017 06:00", 
              "value": 3 
        }, { 
              "date": "03/19/2017 12:00", 
              "value": 4 
        }, { 
              "date": "03/19/2017 18:00", 
              "value": 6 
        }, { 
              "date": "03/20/2017 00:00", 
              "value": 10 
        }, { 
              "date": "03/20/2017 06:00", 
              "value": 1 
        }, { 
              "date": "03/20/2017 12:00", 
              "value": 5 
        }, { 
              "date": "03/20/2017 18:00", 
              "value": 8 
        }, { 
              "date": "03/21/2017 00:00", 
              "value": 8 
        }, { 
              "date": "03/21/2017 06:00", 
              "value": 2 
        }, { 
              "date": "03/21/2017 12:00", 
              "value": 5 
        }, { 
              "date": "03/21/2017 18:00", 
              "value": 8 
        }, { 
              "date": "03/22/2017 00:00", 
              "value": 9 
        }, { 
              "date": "03/22/2017 06:00", 
              "value": 2 
        }, { 
              "date": "03/22/2017 12:00", 
              "value": 4 
        }, { 
              "date": "03/22/2017 18:00", 
              "value": 7 
        }, { 
              "date": "03/23/2017 00:00", 
              "value": 9 
        }, { 
              "date": "03/23/2017 06:00", 
              "value": 1 
        }, { 
              "date": "03/23/2017 12:00", 
              "value": 3 
        }, { 
              "date": "03/23/2017 18:00", 
              "value": 3.5 
        }, { 
              "date": "03/24/2017 00:00", 
              "value": 9 
        }, { 
              "date": "03/24/2017 06:00", 
              "value": 1 
        }, { 
              "date": "03/24/2017 12:00", 
              "value": 3 
        }, { 
              "date": "03/24/2017 18:00", 
              "value": 7 
        }, { 
              "date": "03/25/2017 00:00", 
              "value": 9 
        }, { 
              "date": "03/25/2017 06:00", 
              "value": 2 
        }, { 
              "date": "03/25/2017 12:00", 
              "value": 3 
        }, { 
              "date": "03/25/2017 18:00", 
              "value": 7 
        }, { 
              "date": "03/26/2017 00:00", 
              "value": 9 
        }, { 
              "date": "03/26/2017 06:00", 
              "value": 3 
        }, { 
              "date": "03/26/2017 12:00", 
              "value": 4 
        }, { 
              "date": "03/26/2017 18:00", 
              "value": 6 
        }, { 
              "date": "03/27/2017 00:00", 
              "value": 9 
        }, { 
              "date": "03/27/2017 06:00", 
              "value": 2 
        }, { 
              "date": "03/27/2017 12:00", 
              "value": 4 
        }, { 
              "date": "03/27/2017 18:00", 
              "value": 7 
        }, { 
              "date": "03/28/2017 00:00", 
              "value": 10 
        }, { 
              "date": "03/28/2017 06:00", 
              "value": 1 
        }, { 
              "date": "03/28/2017 12:00", 
              "value": 4 
        }, { 
              "date": "03/28/2017 18:00", 
              "value": 7 
        }, { 
              "date": "03/29/2017 00:00", 
              "value": 8 
        }, { 
              "date": "03/29/2017 06:00", 
              "value": 2 
        }, { 
              "date": "03/29/2017 12:00", 
              "value": 4 
        }, { 
              "date": "03/29/2017 18:00", 
              "value": 8 
        }, { 
              "date": "03/30/2017 00:00", 
              "value": 9 
        }, { 
              "date": "03/30/2017 06:00", 
              "value": 2 
        }, { 
              "date": "03/30/2017 12:00", 
              "value": 4 
        }, { 
              "date": "03/30/2017 18:00", 
              "value": 6 
        }] 

 const predictData = [{"date": "03/15/2017 06:00", 
            "value": 2 
        }, { 
            "date": "03/15/2017 12:00", 
            "value": 4 
        }, { 
              "date": "03/15/2017 18:00", 
              "value": 6 
        }, { 
              "date": "03/16/2017 00:00", 
              "value": 10 
        }, { 
              "date": "03/16/2017 06:00", 
              "value": 3 
        }, { 
              "date": "03/16/2017 12:00", 
              "value": 3 
        }, { 
              "date": "03/16/2017 18:00", 
              "value": 7 
        }, { 
              "date": "03/17/2017 00:00", 
              "value": 9 
        }, { 
              "date": "03/17/2017 06:00", 
              "value": 2 
        }, { 
              "date": "03/17/2017 12:00", 
              "value": 5 
        }, { 
              "date": "03/17/2017 18:00", 
              "value": 7 
        }, { 
              "date": "03/18/2017 00:00", 
              "value": 10 
        }, { 
              "date": "03/18/2017 06:00", 
              "value": 2 
        }, { 
              "date": "03/18/2017 12:00", 
              "value": 3 
        }, { 
              "date": "03/18/2017 18:00", 
              "value": 7 
        }, { 
              "date": "03/19/2017 00:00", 
              "value": 9 
        }, { 
              "date": "03/19/2017 06:00", 
              "value": 3 
        }, { 
              "date": "03/19/2017 12:00", 
              "value": 4 
        }, { 
              "date": "03/19/2017 18:00", 
              "value": 6 
        }, { 
              "date": "03/20/2017 00:00", 
              "value": 10 
        }, { 
              "date": "03/20/2017 06:00", 
              "value": 1 
        }, { 
              "date": "03/20/2017 12:00", 
              "value": 5 
        }, { 
              "date": "03/20/2017 18:00", 
              "value": 8 
        }, { 
              "date": "03/21/2017 00:00", 
              "value": 8 
        }, { 
              "date": "03/21/2017 06:00", 
              "value": 2 
        }, { 
              "date": "03/21/2017 12:00", 
              "value": 5 
        }, { 
              "date": "03/21/2017 18:00", 
              "value": 8 
        }, { 
              "date": "03/22/2017 00:00", 
              "value": 9 
        }, { 
              "date": "03/22/2017 06:00", 
              "value": 2 
        }, { 
              "date": "03/22/2017 12:00", 
              "value": 4 
        }, { 
              "date": "03/22/2017 18:00", 
              "value": 1 
        }, { 
              "date": "03/23/2017 00:00", 
              "value": 1 
        }, { 
              "date": "03/23/2017 06:00", 
              "value": 1 
        }, { 
              "date": "03/23/2017 12:00", 
              "value": 3 
        }, { 
              "date": "03/23/2017 18:00", 
              "value": 3.5 
        }, { 
              "date": "03/24/2017 00:00", 
              "value": 9 
        }, { 
              "date": "03/24/2017 06:00", 
              "value": 1 
        }, { 
              "date": "03/24/2017 12:00", 
              "value": 3 
        }, { 
              "date": "03/24/2017 18:00", 
              "value": 7 
        }, { 
              "date": "03/25/2017 00:00", 
              "value": 9 
        }, { 
              "date": "03/25/2017 06:00", 
              "value": 2 
        }, { 
              "date": "03/25/2017 12:00", 
              "value": 3 
        }, { 
              "date": "03/25/2017 18:00", 
              "value": 7 
        }, { 
              "date": "03/26/2017 00:00", 
              "value": 9 
        }, { 
              "date": "03/26/2017 06:00", 
              "value": 3 
        }, { 
              "date": "03/26/2017 12:00", 
              "value": 4 
        }, { 
              "date": "03/26/2017 18:00", 
              "value": 6 
        }, { 
              "date": "03/27/2017 00:00", 
              "value": 9 
        }, { 
              "date": "03/27/2017 06:00", 
              "value": 2 
        }, { 
              "date": "03/27/2017 12:00", 
              "value": 4 
        }, { 
              "date": "03/27/2017 18:00", 
              "value": 7 
        }, { 
              "date": "03/28/2017 00:00", 
              "value": 10 
        }, { 
              "date": "03/28/2017 06:00", 
              "value": 1 
        }, { 
              "date": "03/28/2017 12:00", 
              "value": 4 
        }, { 
              "date": "03/28/2017 18:00", 
              "value": 7 
        }, { 
              "date": "03/29/2017 00:00", 
              "value": 8 
        }, { 
              "date": "03/29/2017 06:00", 
              "value": 2 
        }, { 
              "date": "03/29/2017 12:00", 
              "value": 4 
        }, { 
              "date": "03/29/2017 18:00", 
              "value": 8 
        }, { 
              "date": "03/30/2017 00:00", 
              "value": 9 
        }, { 
              "date": "03/30/2017 06:00", 
              "value": 2 
        }, { 
              "date": "03/30/2017 12:00", 
              "value": 4 
        }, { 
              "date": "03/30/2017 18:00", 
              "value": 6 
        }] 
    return {trainData, predictData}
}
`

export const textCodeJQ = `

const template = "<prophesier-anomaly-detection></prophesier-anomaly-detection";
const data = getData();
const epsilon = 0.01;
const steps = 4;

const element = $(template)
element.prop({
    traindata: data.trainData,
    predictdata: data.predictData,
    epsilon: espsilon,
    steps: steps
})
$(document.body).append(element)

function getData() {
    const trainData = [{"date": "03/15/2017 06:00", 
            "value": 2
        }, { 
            "date": "03/15/2017 12:00", 
            "value": 4 
        }, { 
              "date": "03/15/2017 18:00", 
              "value": 6 
        }, { 
              "date": "03/16/2017 00:00", 
              "value": 10
        }, { 
              "date": "03/16/2017 06:00", 
              "value": 3 
        }, { 
              "date": "03/16/2017 12:00", 
              "value": 3 
        }, { 
              "date": "03/16/2017 18:00", 
              "value": 7 
        }, { 
              "date": "03/17/2017 00:00", 
              "value": 9 
        }, { 
              "date": "03/17/2017 06:00", 
              "value": 2 
        }, { 
              "date": "03/17/2017 12:00", 
              "value": 5 
        }, { 
              "date": "03/17/2017 18:00", 
              "value": 7 
        }, { 
              "date": "03/18/2017 00:00", 
              "value": 10 
        }, { 
              "date": "03/18/2017 06:00", 
              "value": 2 
        }, { 
              "date": "03/18/2017 12:00", 
              "value": 3 
        }, { 
              "date": "03/18/2017 18:00", 
              "value": 7 
        }, { 
              "date": "03/19/2017 00:00", 
              "value": 9 
        }, { 
              "date": "03/19/2017 06:00", 
              "value": 3 
        }, { 
              "date": "03/19/2017 12:00", 
              "value": 4 
        }, { 
              "date": "03/19/2017 18:00", 
              "value": 6 
        }, { 
              "date": "03/20/2017 00:00", 
              "value": 10 
        }, { 
              "date": "03/20/2017 06:00", 
              "value": 1 
        }, { 
              "date": "03/20/2017 12:00", 
              "value": 5 
        }, { 
              "date": "03/20/2017 18:00", 
              "value": 8 
        }, { 
              "date": "03/21/2017 00:00", 
              "value": 8 
        }, { 
              "date": "03/21/2017 06:00", 
              "value": 2 
        }, { 
              "date": "03/21/2017 12:00", 
              "value": 5 
        }, { 
              "date": "03/21/2017 18:00", 
              "value": 8 
        }, { 
              "date": "03/22/2017 00:00", 
              "value": 9 
        }, { 
              "date": "03/22/2017 06:00", 
              "value": 2 
        }, { 
              "date": "03/22/2017 12:00", 
              "value": 4 
        }, { 
              "date": "03/22/2017 18:00", 
              "value": 7 
        }, { 
              "date": "03/23/2017 00:00", 
              "value": 9 
        }, { 
              "date": "03/23/2017 06:00", 
              "value": 1 
        }, { 
              "date": "03/23/2017 12:00", 
              "value": 3 
        }, { 
              "date": "03/23/2017 18:00", 
              "value": 3.5 
        }, { 
              "date": "03/24/2017 00:00", 
              "value": 9 
        }, { 
              "date": "03/24/2017 06:00", 
              "value": 1 
        }, { 
              "date": "03/24/2017 12:00", 
              "value": 3 
        }, { 
              "date": "03/24/2017 18:00", 
              "value": 7 
        }, { 
              "date": "03/25/2017 00:00", 
              "value": 9 
        }, { 
              "date": "03/25/2017 06:00", 
              "value": 2 
        }, { 
              "date": "03/25/2017 12:00", 
              "value": 3 
        }, { 
              "date": "03/25/2017 18:00", 
              "value": 7 
        }, { 
              "date": "03/26/2017 00:00", 
              "value": 9 
        }, { 
              "date": "03/26/2017 06:00", 
              "value": 3 
        }, { 
              "date": "03/26/2017 12:00", 
              "value": 4 
        }, { 
              "date": "03/26/2017 18:00", 
              "value": 6 
        }, { 
              "date": "03/27/2017 00:00", 
              "value": 9 
        }, { 
              "date": "03/27/2017 06:00", 
              "value": 2 
        }, { 
              "date": "03/27/2017 12:00", 
              "value": 4 
        }, { 
              "date": "03/27/2017 18:00", 
              "value": 7 
        }, { 
              "date": "03/28/2017 00:00", 
              "value": 10 
        }, { 
              "date": "03/28/2017 06:00", 
              "value": 1 
        }, { 
              "date": "03/28/2017 12:00", 
              "value": 4 
        }, { 
              "date": "03/28/2017 18:00", 
              "value": 7 
        }, { 
              "date": "03/29/2017 00:00", 
              "value": 8 
        }, { 
              "date": "03/29/2017 06:00", 
              "value": 2 
        }, { 
              "date": "03/29/2017 12:00", 
              "value": 4 
        }, { 
              "date": "03/29/2017 18:00", 
              "value": 8 
        }, { 
              "date": "03/30/2017 00:00", 
              "value": 9 
        }, { 
              "date": "03/30/2017 06:00", 
              "value": 2 
        }, { 
              "date": "03/30/2017 12:00", 
              "value": 4 
        }, { 
              "date": "03/30/2017 18:00", 
              "value": 6 
        }] 

 const predictData = [{"date": "03/15/2017 06:00", 
            "value": 2 
        }, { 
            "date": "03/15/2017 12:00", 
            "value": 4 
        }, { 
              "date": "03/15/2017 18:00", 
              "value": 6 
        }, { 
              "date": "03/16/2017 00:00", 
              "value": 10 
        }, { 
              "date": "03/16/2017 06:00", 
              "value": 3 
        }, { 
              "date": "03/16/2017 12:00", 
              "value": 3 
        }, { 
              "date": "03/16/2017 18:00", 
              "value": 7 
        }, { 
              "date": "03/17/2017 00:00", 
              "value": 9 
        }, { 
              "date": "03/17/2017 06:00", 
              "value": 2 
        }, { 
              "date": "03/17/2017 12:00", 
              "value": 5 
        }, { 
              "date": "03/17/2017 18:00", 
              "value": 7 
        }, { 
              "date": "03/18/2017 00:00", 
              "value": 10 
        }, { 
              "date": "03/18/2017 06:00", 
              "value": 2 
        }, { 
              "date": "03/18/2017 12:00", 
              "value": 3 
        }, { 
              "date": "03/18/2017 18:00", 
              "value": 7 
        }, { 
              "date": "03/19/2017 00:00", 
              "value": 9 
        }, { 
              "date": "03/19/2017 06:00", 
              "value": 3 
        }, { 
              "date": "03/19/2017 12:00", 
              "value": 4 
        }, { 
              "date": "03/19/2017 18:00", 
              "value": 6 
        }, { 
              "date": "03/20/2017 00:00", 
              "value": 10 
        }, { 
              "date": "03/20/2017 06:00", 
              "value": 1 
        }, { 
              "date": "03/20/2017 12:00", 
              "value": 5 
        }, { 
              "date": "03/20/2017 18:00", 
              "value": 8 
        }, { 
              "date": "03/21/2017 00:00", 
              "value": 8 
        }, { 
              "date": "03/21/2017 06:00", 
              "value": 2 
        }, { 
              "date": "03/21/2017 12:00", 
              "value": 5 
        }, { 
              "date": "03/21/2017 18:00", 
              "value": 8 
        }, { 
              "date": "03/22/2017 00:00", 
              "value": 9 
        }, { 
              "date": "03/22/2017 06:00", 
              "value": 2 
        }, { 
              "date": "03/22/2017 12:00", 
              "value": 4 
        }, { 
              "date": "03/22/2017 18:00", 
              "value": 1 
        }, { 
              "date": "03/23/2017 00:00", 
              "value": 1 
        }, { 
              "date": "03/23/2017 06:00", 
              "value": 1 
        }, { 
              "date": "03/23/2017 12:00", 
              "value": 3 
        }, { 
              "date": "03/23/2017 18:00", 
              "value": 3.5 
        }, { 
              "date": "03/24/2017 00:00", 
              "value": 9 
        }, { 
              "date": "03/24/2017 06:00", 
              "value": 1 
        }, { 
              "date": "03/24/2017 12:00", 
              "value": 3 
        }, { 
              "date": "03/24/2017 18:00", 
              "value": 7 
        }, { 
              "date": "03/25/2017 00:00", 
              "value": 9 
        }, { 
              "date": "03/25/2017 06:00", 
              "value": 2 
        }, { 
              "date": "03/25/2017 12:00", 
              "value": 3 
        }, { 
              "date": "03/25/2017 18:00", 
              "value": 7 
        }, { 
              "date": "03/26/2017 00:00", 
              "value": 9 
        }, { 
              "date": "03/26/2017 06:00", 
              "value": 3 
        }, { 
              "date": "03/26/2017 12:00", 
              "value": 4 
        }, { 
              "date": "03/26/2017 18:00", 
              "value": 6 
        }, { 
              "date": "03/27/2017 00:00", 
              "value": 9 
        }, { 
              "date": "03/27/2017 06:00", 
              "value": 2 
        }, { 
              "date": "03/27/2017 12:00", 
              "value": 4 
        }, { 
              "date": "03/27/2017 18:00", 
              "value": 7 
        }, { 
              "date": "03/28/2017 00:00", 
              "value": 10 
        }, { 
              "date": "03/28/2017 06:00", 
              "value": 1 
        }, { 
              "date": "03/28/2017 12:00", 
              "value": 4 
        }, { 
              "date": "03/28/2017 18:00", 
              "value": 7 
        }, { 
              "date": "03/29/2017 00:00", 
              "value": 8 
        }, { 
              "date": "03/29/2017 06:00", 
              "value": 2 
        }, { 
              "date": "03/29/2017 12:00", 
              "value": 4 
        }, { 
              "date": "03/29/2017 18:00", 
              "value": 8 
        }, { 
              "date": "03/30/2017 00:00", 
              "value": 9 
        }, { 
              "date": "03/30/2017 06:00", 
              "value": 2 
        }, { 
              "date": "03/30/2017 12:00", 
              "value": 4 
        }, { 
              "date": "03/30/2017 18:00", 
              "value": 6 
        }] 
    return {trainData, predictData}
}
`





// WEBPACK FOOTER //
// ./src/samples/AnomalyReact.js